export default __webpack_public_path__ + "static/media/GettyImages-200548159-003-581034de5f9b58564c99611a.1c0b3fc7.webp";